export default __webpack_public_path__ + "static/media/ibm.61faf07e.svg";